// Broadcast stat cards (WP-02 / WhatChimp §1.5).
// 5 high-level 30-day metric cards: Total campaigns, Completed, Avg open rate, Total sent, Failed/Unreached %.

import { useI18n } from '../../lib/i18n';
import { StatCard } from '../ui/StatCard';
import { Skeleton } from '../ui/Skeleton';
import {
  BroadcastingIcon,
  CheckIcon,
  EyeIcon,
  SendIcon,
  AlertTriangleIcon,
} from '../icons';
import type { BroadcastStats } from '../../lib/broadcasts';

interface BroadcastStatCardsProps {
  stats: BroadcastStats | null;
  loading?: boolean;
}

export function BroadcastStatCards({ stats, loading }: BroadcastStatCardsProps) {
  const { t } = useI18n();

  if (loading) {
    return (
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
        <Skeleton.StatCard />
        <Skeleton.StatCard />
        <Skeleton.StatCard />
        <Skeleton.StatCard />
        <Skeleton.StatCard />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
      <StatCard
        label={t('bcast.stats.totalCampaigns')}
        value={stats ? stats.totalCampaigns.toLocaleString() : '0'}
        caption={t('bcast.stats.rolling30Days')}
        icon={<BroadcastingIcon size={20} />}
        variant="indigo"
      />
      <StatCard
        label={t('bcast.stats.completed')}
        value={loading ? '—' : stats ? stats.completed.toLocaleString() : '0'}
        caption={t('bcast.stats.completedSub')}
        icon={<CheckIcon size={20} />}
        variant="green"
      />
      <StatCard
        label={t('bcast.stats.avgOpenRate')}
        value={loading ? '—' : stats ? `${stats.avgOpenRate}%` : '0%'}
        caption={t('bcast.stats.avgOpenRateSub')}
        icon={<EyeIcon size={20} />}
        variant="amber"
      />
      <StatCard
        label={t('bcast.stats.totalSent')}
        value={loading ? '—' : stats ? stats.totalSent.toLocaleString() : '0'}
        caption={t('bcast.stats.totalSentSub')}
        icon={<SendIcon size={20} />}
        variant="sky"
      />
      <StatCard
        label={t('bcast.stats.failedRate')}
        value={loading ? '—' : stats ? `${stats.failedUnreachedRate}%` : '0%'}
        caption={t('bcast.stats.failedRateSub')}
        icon={<AlertTriangleIcon size={20} />}
        variant="rose"
      />
    </div>
  );
}
